<template>
  <div>
    <van-cell-group>
      <van-cell :title="$t('shop.Add_item')" is-link @click="addShop"/>
      <van-cell :title="$t('shop.Product_list')" is-link @click="shop_product_list"/>
    </van-cell-group>
  </div>
</template>

<script>
    export default {
        name: "shop_manage",
        created: function () {
            document.title = this.$t('shop.Store_management');
        },
        methods: {
            addShop: function () {
                //添加商品
                const uid = this.$route.query.uid;
                const token = this.$route.query.token;
                this.$router.push({path: '/ShopAdd', query: {uid: uid, token: token}});
            },
            shop_product_list: function () {
                //添加商品
                const token = this.$route.query.token;
                const uid = this.$route.query.uid;
                this.$router.push({path: '/shopList', query: {uid: uid, token: token}});
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shop_manage.vue